import { get, post } from "lib/fetch";
import { ICreateSubject, IUpdateSubject } from "store/types";

export const GET_SUBJECTS = "subjects/GET";
export const GET_SUBJECT = "subject/GET_ONE";
export const CREATE_SUBJECT = "subject/CREATE";
export const UPDATE_SUBJECT = "subject/UPDATE";
export const ADD_SUBJECT_UPDATE_ID = "subject/ADD_UPDATE_ID";
export const REMOVE_SUBJECT_UPDATE_ID = "subject/REMOVE_UPDATE_ID";

export const getSubjects = (searchString?: string) => ({
  type: GET_SUBJECTS,
  payload: searchString ? get(`/v1/sites?search=${searchString}`) : get("/v1/sites"),
});

export const getSubject = (id?: number | null) => ({
  type: GET_SUBJECT,
  payload: get(`/v1/site/${id}`),
});

export const createSubject = (payload: ICreateSubject) => ({
  type: CREATE_SUBJECT,
  payload: post(`/v1/site`, payload),
});

export const updateSubject = (payload: IUpdateSubject) => ({
  type: UPDATE_SUBJECT,
  payload: post(`/v1/site/`, payload),
});

export const addSubjectUpdateId = (id: string) => ({
  type: ADD_SUBJECT_UPDATE_ID,
  payload: id,
});

export const removeSubjectUpdateId = (id: string) => ({
  type: REMOVE_SUBJECT_UPDATE_ID,
  payload: id,
});
